
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Text,
  Icon,
} from '@drawbotics/react-drylus';
import { Map } from '@drawbotics/react-drylus/map';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Map`}</h1>
<p>{`Used to display one or more points of interest on a map. This component uses `}<a parentName="p" {...{
        "href": "https://www.mapbox.com/"
      }}><inlineCode parentName="a">{`mapbox`}</inlineCode></a>{` internally, and `}<a parentName="p" {...{
        "href": "https://github.com/MeilleursAgents/react-mapbox-wrapper"
      }}><inlineCode parentName="a">{`react-mapbox-wrapper`}</inlineCode></a>{`.`}</p>
<p><strong parentName="p">{`Usage`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Map } from '@drawbotics/react-drylus/map';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<p>{`The props shown here are only the most common ones, if you need more interactivity you can look at the available props `}<a parentName="p" {...{
        "href": "https://github.com/MeilleursAgents/react-mapbox-wrapper#api"
      }}>{`here`}</a>{`.`}</p>
<p>{`To customize the markers and their interaction, you can use the `}<inlineCode parentName="p">{`options`}</inlineCode>{` field (see `}<inlineCode parentName="p">{`markers`}</inlineCode>{` in table) and use any option from the documentation of `}<inlineCode parentName="p">{`react-mapbox-wrapper`}</inlineCode>{`.`}</p>
<p>{`When passing a `}<inlineCode parentName="p">{`title`}</inlineCode>{` (and `}<inlineCode parentName="p">{`subtitle`}</inlineCode>{`) to an option, a `}<inlineCode parentName="p">{`Popover`}</inlineCode>{` will be rendered which is visible once the marker is clicked. If only `}<inlineCode parentName="p">{`subtitle`}</inlineCode>{` is given, the popover is not rendered.`}</p>
<blockquote>
<p parentName="blockquote">{`Map example requires `}<inlineCode parentName="p">{`MAPBOX_ACCESS_TOKEN`}</inlineCode>{` in your `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file.`}</p>
</blockquote>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;